export const GET_BEAUTY_PRODUCTS_BEGIN = 'GET_BEAUTY_PRODUCTS_BEGIN'
export const GET_BEAUTY_PRODUCTS_SUCCESS = 'GET_BEAUTY_PRODUCTS_SUCCESS'
export const GET_BEAUTY_PRODUCTS_ERROR = 'GET_BEAUTY_PRODUCTS_ERROR'
export const GET_DECOR_PRODUCTS_BEGIN='GET_BEAUTY_PRODUCTS_BEGIN'
export const GET_DECOR_PRODUCTS_SUCCESS='GET_BEAUTY_PRODUCTS_SUCCESS'
export const GET_DECOR_PRODUCTS_ERROR = 'GET_BEAUTY_PRODUCTS_ERROR'
export const GET_ELECTRONIC_PRODUCTS_BEGIN='GET_ELECTRONIC_PRODUCTS_BEGIN'
export const GET_ELECTRONIC_PRODUCTS_SUCCESS='GET_ELECTRONIC_PRODUCTS_SUCCESS'
export const GET_ELECTRONIC_PRODUCTS_ERROR = 'GET_ELECTRONIC_PRODUCTS_ERROR'
export const GET_FASHION_PRODUCTS_BEGIN='GET_FASHION_PRODUCTS_BEGIN'
export const GET_FASHION_PRODUCTS_SUCCESS='GET_FASHION_PRODUCTS_SUCCESS'
export const GET_FASHION_PRODUCTS_ERROR = 'GET_FASHION_PRODUCTS_ERROR'
export const GET_JEWELRY_PRODUCTS_BEGIN='GET_JEWELRY_PRODUCTS_BEGIN'
export const GET_JEWELRY_PRODUCTS_SUCCESS='GET_JEWELRY_PRODUCTS_SUCCESS'
export const GET_JEWELRY_PRODUCTS_ERROR = 'GET_JEWELRY_PRODUCTS_ERROR'
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS'
export const UPDATE_SORT = 'UPDATE_SORT'
export const SORT_PRODUCTS = 'SORT_PRODUCTS'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const FILTER_PRODUCTS='FILTER_PRODUCTS'